import * as React from 'react';
import { AccordionItemContext, } from '../accordion-item/accordion-item-context';
export default class AccordionArrowCore extends React.Component {
    BEM() {
        const classArray = ['accordion__arrow'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const { Icon } = this.props.components;
        return (React.createElement("a", { className: this.BEM(), href: '#' + this.props.id, onClick: this.props.onClick, onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave, "aria-hidden": true, tabIndex: -1 },
            React.createElement(Icon, { className: "accordion__arrow-icon", modifiers: "#arrow-down" })));
    }
}
AccordionArrowCore.contextType = AccordionItemContext;
